import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  importZonesFailed, importZonesSuccessful,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* importZones(action) {
  try {
    const headers = {
      Accept: 'multipart/form-data',
      'Content-Type': 'multipart/form-data',
    };
    const pool = action.payload;
    const url = `${BACKEND_URL}/zones/import`;
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true, headers, true);
    if (dataResponse.status === OK) {
      yield put(importZonesSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const data = yield getBodyJson(dataResponse);
      yield put(importZonesFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(importZonesFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
